"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfTopicSubscriptionUpdateDto = instanceOfTopicSubscriptionUpdateDto;
exports.TopicSubscriptionUpdateDtoFromJSON = TopicSubscriptionUpdateDtoFromJSON;
exports.TopicSubscriptionUpdateDtoFromJSONTyped = TopicSubscriptionUpdateDtoFromJSONTyped;
exports.TopicSubscriptionUpdateDtoToJSON = TopicSubscriptionUpdateDtoToJSON;
exports.TopicSubscriptionUpdateDtoToJSONTyped = TopicSubscriptionUpdateDtoToJSONTyped;
/**
 * Check if a given object implements the TopicSubscriptionUpdateDto interface.
 */
function instanceOfTopicSubscriptionUpdateDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('subscribed' in value) || value['subscribed'] === undefined)
        return false;
    return true;
}
function TopicSubscriptionUpdateDtoFromJSON(json) {
    return TopicSubscriptionUpdateDtoFromJSONTyped(json, false);
}
function TopicSubscriptionUpdateDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'subscribed': json['subscribed'],
        'digestScheduleId': json['digestScheduleId'] == null ? undefined : json['digestScheduleId'],
    };
}
function TopicSubscriptionUpdateDtoToJSON(json) {
    return TopicSubscriptionUpdateDtoToJSONTyped(json, false);
}
function TopicSubscriptionUpdateDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'subscribed': value['subscribed'],
        'digestScheduleId': value['digestScheduleId'],
    };
}
//# sourceMappingURL=TopicSubscriptionUpdateDto.js.map